/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTopChartingProductsQueryVariables = Types.Exact<{
  label_id: Types.InputMaybe<Types.Scalars['String']>;
  space_id: Types.InputMaybe<Types.Scalars['String']>;
  countryCode: Types.Scalars['String'];
  limit: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetTopChartingProductsQuery = { __typename: 'Query', getTopChartingProducts: Array<{ __typename: 'Chart', id: string, campaign_id: number | null, artist: string | null, title: string | null, chart: string | null, configuration: string | null, parent_id: number | null, rank: number | null }> | null };


export const GetTopChartingProductsDocument = gql`
    query getTopChartingProducts($label_id: String, $space_id: String, $countryCode: String!, $limit: Int) {
  getTopChartingProducts(
    label_id: $label_id
    space_id: $space_id
    countryCode: $countryCode
    limit: $limit
  ) {
    id
    campaign_id
    artist
    title
    chart
    configuration
    parent_id
    rank
  }
}
    `;

/**
 * __useGetTopChartingProductsQuery__
 *
 * To run a query within a React component, call `useGetTopChartingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopChartingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopChartingProductsQuery({
 *   variables: {
 *      label_id: // value for 'label_id'
 *      space_id: // value for 'space_id'
 *      countryCode: // value for 'countryCode'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopChartingProductsQuery(baseOptions: Apollo.QueryHookOptions<GetTopChartingProductsQuery, GetTopChartingProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopChartingProductsQuery, GetTopChartingProductsQueryVariables>(GetTopChartingProductsDocument, options);
      }
export function useGetTopChartingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopChartingProductsQuery, GetTopChartingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopChartingProductsQuery, GetTopChartingProductsQueryVariables>(GetTopChartingProductsDocument, options);
        }
export type GetTopChartingProductsQueryHookResult = ReturnType<typeof useGetTopChartingProductsQuery>;
export type GetTopChartingProductsLazyQueryHookResult = ReturnType<typeof useGetTopChartingProductsLazyQuery>;